import { createActionCreator } from "common/ReduxUtils";
import { StorageInboundCreateActionTypes } from "../StorageInboundCreateAction.types";

export const setStorageInboundOrderId = createActionCreator<number>(
  StorageInboundCreateActionTypes.SET_STORAGE_INBOUND_ORDER_ID,
  "storageInboundOrderId"
);
